export { default } from "./SwiperVideo"
